import { MenuProps } from "antd";
import {ScaleMenu} from "@/shared/api/model";
import { Link } from "react-router-dom";
import { getIcon } from "@/libs/side-bar/icon-loader";

type MenuItem = Required<MenuProps>['items'][number];

const getMenu = ({ id, page, label, icon, items, type }: ScaleMenu): MenuItem | null => {
    const href = (!page) ? "" : page;
    // If it's a subMenu with no children, return null
    if (type === "subMenu" && (!items || items.length === 0)) {
        return null;
    }

    return {
        key: id,
        icon: getIcon(icon),
        children: items?.map(item => getMenu(item as ScaleMenu)).filter(Boolean) as MenuItem[],
        label: (type === "menuItem") ? (
            <Link to={href}>
                <span className="label">{label}</span>
            </Link>
        ) : (
            <span className="label">{label}</span>
        ),
        type,
    } as MenuItem;
};

export default getMenu;